import { buildActivityKey } from "./reportModel";

/**
 * Resolves which photos are selected for one activity, using the SAME
 * (mIdx,tIdx,aIdx)->key computation everywhere it's called (seeding,
 * togglePhoto's fallback, the checkbox render loop, prepareForPrint, and
 * the per-equipment ZIP export). This is the single source of truth that
 * replaces the previously duplicated inline `selected ? filter : slice`
 * logic scattered across Report.js.
 *
 * @param {number} mIdx
 * @param {number} tIdx
 * @param {number} aIdx
 * @param {string[]} files - all photo URLs available for this activity
 * @param {Object.<string, Set<string>>} photoSelection - keyed by buildActivityKey
 * @param {number} maxPhotos - site-wide config cap (maxFotosInforme)
 * @returns {string[]} the selected photo URLs, in `files` order
 */
export const resolveSelectedPhotos = (
  mIdx,
  tIdx,
  aIdx,
  files,
  photoSelection,
  maxPhotos
) => {
  const list = files || [];
  const key = buildActivityKey(mIdx, tIdx, aIdx);
  const selected = photoSelection ? photoSelection[key] : undefined;
  return selected ? list.filter((f) => selected.has(f)) : list.slice(0, maxPhotos);
};
